<nz-tabset
  nzType="card"
  class="bordered-tabs six-option"
  [nzTabBarExtraContent]="extraTemplate"
  [(nzSelectedIndex)]="selectedTabIndex">
  <nz-tab nzTitle="Options" class="cases-tab">
    <app-options *ngIf="selectedTabIndex === 0" />
  </nz-tab>
  <nz-tab nzTitle="Branding" class="students-tab">
    <app-branding *ngIf="selectedTabIndex === 1" />
  </nz-tab>
  <nz-tab nzTitle="Titles" class="students-tab">
    <app-titles *ngIf="selectedTabIndex === 2" />
  </nz-tab>
  <nz-tab nzTitle="Custom Question" class="students-tab"
    ><app-custom-question
      *ngIf="selectedTabIndex === 3"
      [orgParams]="orgParams"
  /></nz-tab>
  <nz-tab nzTitle="LMS Settings" class="students-tab"
    ><app-lms-settings [isMangeOption]="true" *ngIf="selectedTabIndex === 4"
  /></nz-tab>
  <nz-tab nzTitle="Report Labels" class="students-tab"
    ><app-report-labels *ngIf="selectedTabIndex === 5"
  /></nz-tab>
</nz-tabset>
<ng-template #extraTemplate>
  <div class="cta-wrapper" *ngIf="selectedTabIndex === 2">
    <button
      nz-button
      type="button"
      [nzType]="'primary'"
      (click)="addNewTitle()">
      Add New Title
    </button>
  </div>
</ng-template>
